
import Vue from 'vue';
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(
    'section',
    { staticClass: 'about' },
    [_c('secondary-nav'), _c('div', { staticClass: 'su-body' }, [_vm._m(0), _c('footer-row')], 1)],
    1,
  );
};
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c;
    return _c('div', { staticClass: 'about-us-section container' }, [
      _c('div', { staticClass: 'row' }, [
        _c('div', { staticClass: 'col-1 void-column' }),
        _c('div', { staticClass: 'col-12 col-md-11' }, [
          _c('div', { staticClass: 'row' }, [
            _c('div', { staticClass: 'col-12' }, [_c('h1', [_vm._v(' Our partners ')])]),
            _c(
              'div',
              {
                staticClass:
                  'partner-content col-12 col-md-6 d-flex align-items-center flex-column',
              },
              [_c('div', { staticClass: 'partner-card msc' })],
            ),
            _c(
              'div',
              {
                staticClass:
                  'partner-content col-12 col-md-6 d-flex align-items-center flex-column',
              },
              [_c('div', { staticClass: 'partner-card artled' })],
            ),
            _c(
              'div',
              {
                staticClass:
                  'partner-content col-12 col-md-6 d-flex align-items-center flex-column',
              },
              [
                _c('div', { staticClass: 'partner-card beautiful-card flex-column' }, [
                  _c('a', { attrs: { href: 'https://beautifullife.cc/' } }, [
                    _c('div', [_vm._v('Beautiful Life')]),
                    _c('div', { staticStyle: { 'font-weight': '200', 'font-size': '23.6px' } }, [
                      _vm._v('Creative Studio'),
                    ]),
                  ]),
                ]),
              ],
            ),
            _c(
              'div',
              {
                staticClass:
                  'partner-content col-12 col-md-6 d-flex align-items-center flex-column',
              },
              [_c('div', { staticClass: 'partner-card nuthouse' })],
            ),
            _c(
              'div',
              {
                staticClass:
                  'partner-content col-12 col-md-6 d-flex align-items-center flex-column',
              },
              [_c('div', { staticClass: 'partner-card dvstudios' })],
            ),
            _c(
              'div',
              {
                staticClass:
                  'partner-content col-12 col-md-6 d-flex align-items-center flex-column',
              },
              [_c('div', { staticClass: 'partner-card alice' })],
            ),
          ]),
        ]),
      ]),
    ]);
  },
];

export default Vue.extend({ render, staticRenderFns });
